module.exports = __webpack_public_path__ + "static/media/watch.fe8f5863.svg";